import { useMemo } from "react";
import { textOverflow } from "Utils/Styles";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `Chip`,
  field: `ChipFieldName`,
  fieldText: `ChipFieldNameText`,
  arrowRight: `ChipArrowRight`,
  search: `ChipSearch`,
  searchText: `ChipSearchText`,
  icon: `ChipIcon`
};

export function useChipStyles() {
  const { semanticColors, effects, fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          alignItems: `center`,
          backgroundColor: semanticColors.buttonBackground,
          border: `none`,
          borderRadius: `5px`,
          boxShadow: effects.elevation4,
          boxSizing: `border-box`,
          color: semanticColors.buttonText,
          cursor: `pointer`,
          display: `inline-flex`,
          fontFamily: fonts.small.fontFamily,
          fontSize: fonts.small.fontSize,
          height: `32px`,
          justifyContent: `center`,
          marginTop: `5px`,
          outline: 0,
          overflow: `hidden`,
          padding: 0,
          selectors: {
            "&:hover": {
              backgroundColor: semanticColors.inputPlaceholderBackgroundChecked
            }
          },
          textDecoration: `none`,
          transition: `background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
          verticalAlign: `middle`
        }
      ],
      field: [
        classNames.field,
        {
          alignItems: `center`,
          backgroundColor: semanticColors.primaryButtonBackground,
          borderBottomLeftRadius: `5px`,
          borderTopLeftRadius: `5px`,
          boxSizing: `border-box`,
          color: semanticColors.primaryButtonText,
          display: `inline-flex`,
          height: `100%`,
          maxWidth: `70px`,
          minWidth: `0px`,
          padding: `0 3px 0 12px`,
          zIndex: 10
        }
      ],
      fieldText: [
        classNames.fieldText,
        {
          color: semanticColors.primaryButtonText,
          fontWeight: 600,
          ...textOverflow
        }
      ],
      arrowRight: [
        classNames.arrowRight,
        {
          borderBottom: `32px solid transparent`,
          borderLeft: `32px solid ${semanticColors.primaryButtonBackground}`,
          borderTop: `32px solid transparent`,
          height: 0,
          marginLeft: `-16px`,
          width: 0
        }
      ],
      search: [
        classNames.search,
        {
          alignItems: `center`,
          color: semanticColors.inputPlaceholderBackgroundChecked,
          display: `inline-flex`,
          height: `100%`,
          maxWidth: `125px`,
          padding: `0 12px`
        }
      ],
      searchText: [classNames.searchText, { ...textOverflow }],
      icon: [
        classNames.icon,
        {
          color: semanticColors.buttonTextDisabled,
          display: `inline-block`,
          fill: `currentColor`,
          flexShrink: 0,
          fontSize: `1.5rem`,
          height: `22px`,
          margin: `0 5px 0 -6px`,
          paddingLeft: `2px`,
          transition: `fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
          userSelect: `none`,
          width: `22px`,
          selectors: {
            ":hover": {
              backgroundColor: semanticColors.buttonBackgroundDisabled,
              borderRadius: `22px`
            }
          },
          [`.${classNames.root}:hover &`]: {
            color: semanticColors.buttonText
          }
        }
      ]
    }),
    [effects, fonts, semanticColors]
  );
}
